import React from "react";
import __ from "src/utils/Translations";

export const getLocalizationsImportInstructions = (): React.ReactNode[] => [
  <>
    {__("Pierwszy wiersz pełni funkcję nagłówka, a")}{" "}
    <strong>{__("import danych rozpoczyna się od drugiego wiersza.")}</strong>{" "}
    {__("Zawartość pierwszego wiersza nie jest przetwarzana.")}
  </>,
  <>
    {__("Każdy wiersz w pliku powinien zawierać maksymalnie 4 kolumny.")}{" "}
    <strong>{__("Wypełniasz tylko te pola, które chcesz uzupełnić")}</strong>
    {" - "}
    {__("pozostałe możesz zostawić puste.")}
  </>,
  <>
    <strong>
      {__("Import służy wyłącznie do dodawania nowych lokalizacji")}
    </strong>
    {" - "}
    {__("nie można przez niego edytować istniejących wpisów.")}{" "}
    <strong>
      {__("Edycja odbywa się ręcznie przez panel administracyjny.")}
    </strong>
  </>,
  <>
    {__(
      "Lokalizacje, których nazwa pokrywa się z już istniejącą pozycją w słowniku (z pominięciem wielkości liter i zbędnych spacji), zostaną pominięte z ostrzeżeniem."
    )}
  </>,
  <>
    <strong>{__("Możesz skorzystać z gotowego szablonu")}</strong>{" "}
    {__("z nazwami kolumn lub wyeksportować aktualną listę lokalizacji.")}
  </>,
  <>
    {__("Oczekiwany format plików to")}{" "}
    <strong>{__("CSV UTF-8 rozdzielany średnikami")}</strong>
  </>,
];

export const getLocalizationsUpdateFields = (): string[] => [
  __("Miasto"),
  __("Kod pocztowy"),
  __("Ulica i numer"),
];
